import React from 'react';
import { useFilterContext } from '../../context/aptmetrix/FilterContext';
import { useTooltip } from './useTooltip';
import FilterButton from './FilterButton';
import TooltipShell, { FilterActions } from './TooltipShell';

const WALKING_TIME_OPTIONS = [5, 10, 15, 20, 30];

const WalkingTimeFilter = ({ isOpen, onToggle, onClose, selectedRegion, data, onSubwayFilterChange }) => {
    const {
        filterUIState,
        setFilterUIState,
    } = useFilterContext();

    const { maxWalkingTime, isWalkingTimeFilterActive, selectedSubwayLines } = filterUIState;

    const { tooltipRef, buttonRef } = useTooltip(isOpen, onClose);

    const updateUI = (updates) => setFilterUIState(prev => ({ ...prev, ...updates }));

    const handleToggle = () => {
        if (!selectedRegion) {
            alert('지역을 먼저 선택하세요');
            return;
        }
        onToggle();
    };

    const handleTimeChange = (minutes) => {
        updateUI({ maxWalkingTime: maxWalkingTime === minutes ? null : minutes });
    };

    const apply = () => {
        const isActive = maxWalkingTime !== null;
        updateUI({ isWalkingTimeFilterActive: isActive });
        const lines = selectedSubwayLines.length > 0 ? selectedSubwayLines : null;
        onSubwayFilterChange({
            lines,
            maxWalkingTime: isActive ? maxWalkingTime : null,
        });
        onClose();
    };

    const reset = () => {
        updateUI({ maxWalkingTime: null, isWalkingTimeFilterActive: false });
        if (selectedSubwayLines.length > 0) {
            onSubwayFilterChange({ lines: selectedSubwayLines, maxWalkingTime: null });
        } else {
            onSubwayFilterChange(null);
        }
        onClose();
    };

    const isDisabled = !data || data.length === 0;

    return (
        <div className="relative">
            <FilterButton
                ref={buttonRef}
                label="지하철도보시간"
                activeLabel={`${maxWalkingTime}분이내`}
                isActive={isWalkingTimeFilterActive}
                isDisabled={isDisabled}
                onClick={handleToggle}
            />
            {isOpen && (
                <TooltipShell ref={tooltipRef} title="지하철 도보 시간 필터 설정" onClose={onClose}>
                    <div className="mb-3">
                        <h4 className="text-sm font-medium mb-2">도보 시간 제한</h4>
                        <div className="flex flex-wrap gap-2">
                            {WALKING_TIME_OPTIONS.map(minutes => (
                                <button
                                    key={minutes}
                                    onClick={() => handleTimeChange(minutes)}
                                    className={`px-2 py-1 text-xs rounded-full ${
                                        maxWalkingTime === minutes
                                            ? 'bg-blue-500 text-white'
                                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                    }`}
                                >
                                    {minutes}분 이내
                                </button>
                            ))}
                        </div>
                    </div>
                    <FilterActions onReset={reset} onApply={apply} />
                </TooltipShell>
            )}
        </div>
    );
};

export default WalkingTimeFilter;
